<div *transloco="let t" class="checkBoxInput row-center" (click)="disabled === true ? '' : tickCheckbox()" [style]="style">

  <div style="position: relative; align-self: flex-start;" >
    <label readonly [ngModel]="items[field]" nz-checkbox>
    </label>

    <div style="background-color: transparent; z-index: 5; position: absolute; top: 0; height: 40px; width: 40px;">

    </div>
  </div>


  <div class="body-sm-medium">{{ t(description) }}</div>
</div>
